import React from 'react'

import { Summary, SummaryCounters } from '../../../components/Summary/Summary'
import { Tenant } from '../models'

const buildTenantsSummaryCounters = () => ({
  active: { value: 0, title: 'Customers' },
  isTrial: { value: 0, title: 'Trial' },
  isDemo: { value: 0, title: 'Demo' },
  total: { value: 0, title: 'Total' },
})

const calculateSummary = (tenants: Tenant[]): SummaryCounters => {
  const counters = buildTenantsSummaryCounters()

  return tenants.reduce((summary, tenant) => {
    summary.isTrial.value += tenant.isTrial ? 1 : 0
    summary.isDemo.value += tenant.isDemo ? 1 : 0
    summary.active.value += !tenant.isDemo && !tenant.isTrial ? 1 : 0
    summary.total.value += 1

    return summary
  }, counters)
}

export const TenantsSummary = ({ tenants = [] }: { tenants: Tenant[] }) => (
  <Summary items={tenants} calculateSummaryItemsFunction={calculateSummary} />
)
